import QueryString from 'qs';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import Button from '../../Button';
import ExtendButton from '../../ExtendButton';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import { infoVariant, successVariant, warningVariant } from '../../../lib/barVariant';
import { usePaymentSemestersMutation } from '../../../api/semester/semestersManagement.api';
import { doGetClassStudents } from '../../../store/classStudent.slice';
import Loader from '../../Loader';

interface IProps {
  isExtended: boolean;
  campusDeactived: boolean;
  setIsExtended: (isExtended: boolean) => void;
  setTab: (tab: string) => void;
  classCode?: string | undefined;
  semesterCode?: string;
}

const ClassTopButtons: FC<IProps> = ({ isExtended, setIsExtended, setTab, campusDeactived, classCode, semesterCode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { auth, currentCampus, currentSemesterCode } = useSelector((state: RootState) => state.auth);
  const { enqueueSnackbar } = useSnackbar();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const [paymentSemestersTrigger, {data, isLoading, isFetching, isSuccess}] = usePaymentSemestersMutation();

  const handleSemesterPayment = () => {
    if (!currentCampus) {
      enqueueSnackbar(t('class.class.12'), infoVariant)
      return;
    }

    if (!semesterCode) {
      enqueueSnackbar(t('class.class.13'), infoVariant);
      return;
    }

    paymentSemestersTrigger({campusCode: currentCampus, semesterCode: semesterCode});
  }

  useEffect(() => {
    if (isFetching || !isSuccess) return;

    if (data.result === "fail") {
      enqueueSnackbar(t('class.class.14'), warningVariant);
      return;
    }


    if (!isFetching && isSuccess) {
      enqueueSnackbar(t('class.class.15'), successVariant);

      if (!classCode) return;
      dispatch(doGetClassStudents(classCode));
    }
  }, [data, isFetching, isSuccess]);

  return (
    <>
      {isLoading && <Loader />}
      <div className="comm-btn__area comm-btn_class2 right">
        {
          (auth.hqYn === 'Y' && ['CB00000002', 'CB00000005'].includes(currentCampus))
          && (
            <Button
              className='btn-basic pink-line'
              text={t('class.class.16')}
              onClick={handleSemesterPayment}
              writeAuthYn={writeAuthYn}
            />
          )
        }
        <Button
          className='btn-basic pink'
          onClick={() => {
            const params: any = { ...query, tab: 'createClass' };
            delete params.classCode;
            history.push(`/class/class2?${QueryString.stringify(params)}`);
          }}
          text={t('class.class.button4')}
          disabled={campusDeactived}
          writeAuthYn={writeAuthYn}
        />
      </div>
  </>
  );
}

export default ClassTopButtons;
